export const getToolboxBasicMenu = function (): any {
    let paramJsonObj = {
        show: true,
        itemGap: 10,
        showTitle: false,
        right: "10px", // 右边距
        top: "0%", // 上边距
        itemSize: 14, //工具栏 icon 的大小
        feature: {
            mytool: {
                show: true,
                title: "菜单",
                icon: 'path://M128.13 255.96h767.89c23.56 0 42.66-19.1 42.66-42.66s-19.1-42.66-42.66-42.66H128.13c-23.56 0-42.66 19.1-42.66 42.66s19.1 42.66 42.66 42.66zM896.02 469.27H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66zM896.02 767.89H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66z',
                onclick: ($event) => {
                    // var menupanel = <HTMLElement>$event.scheduler.api.getDom().parentNode.previousSibling;
                    var menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    if (menupanel.hasChildNodes()) {
                        menupanel.firstElementChild.setAttribute('style', 'display:block')
                    }
                }
            }
        },
    };
    return paramJsonObj;
};

export const getToolboxIncludeCalc = function (style, callback?: ($event, ...arg: any[]) => void): any {
    let paramJsonObj = {
        show: true,
        itemGap: 10,
        showTitle: false,
        right: "10px", // 右边距
        top: "0%", // 上边距
        itemSize: style.toolboxSize, //工具栏 icon 的大小
        feature: {
            brush: {
                show: true,
                type: ['lineX', 'clear'],
            },
            mycalc: {
                show: true,
                title: '计算',
                // icon: 'path://M841.42 1022.054H163.329A111.974 111.974 0 0 1 51.2 909.926V112.128C51.2 50.074 101.274 0 163.328 0h678.093c62.003 0 112.128 50.074 112.128 112.128v797.798c0 62.055-50.125 112.128-112.128 112.128zM163.329 65.331a47.872 47.872 0 0 0-46.797 46.797v797.798c0 26.112 20.634 46.797 46.797 46.797h678.093c26.112 0 46.797-20.685 46.797-46.797V112.128a46.438 46.438 0 0 0-46.797-46.797H163.328z m546.355 376.576H296.09c-42.445 0-76.186-33.792-76.186-76.185V231.834c0-42.445 33.792-76.186 76.186-76.186h413.593c42.496 0 76.186 33.74 76.186 76.186v133.888c0 42.444-33.741 76.185-76.186 76.185zM296.09 220.928c-5.428 0-10.855 3.277-10.855 10.906v133.888c0 5.427 5.427 10.854 10.855 10.854h413.593a11.725 11.725 0 0 0 10.906-10.854V231.834a11.725 11.725 0 0 0-10.906-10.906H296.09z m-65.28 383.13a65.331 65.331 0 1 0 130.56 0 65.331 65.331 0 0 0-130.56 0z m206.796 0a65.331 65.331 0 1 0 130.56 0 65.331 65.331 0 0 0-130.56 0z m206.797 0a65.331 65.331 0 1 0 130.56 0 65.331 65.331 0 0 0-130.56 0zM230.81 800a65.331 65.331 0 1 0 130.56 0 65.331 65.331 0 0 0-130.56 0z m206.796 0a65.331 65.331 0 1 0 130.56 0 65.331 65.331 0 0 0-130.56 0z m206.797 0a65.331 65.331 0 1 0 130.56 0 65.331 65.331 0 0 0-130.56 0z',
                icon: 'path://M721 607.5H592.9c-8.6 0-15.9 7.2-15.9 16 0 8.9 7.1 16 15.9 16H721c8.6 0 15.9-7.2 15.9-16 0-8.9-7.2-16-15.9-16m0-239.8H592.9c-8.6 0-15.9 7.2-15.9 16 0 8.9 7.1 16 15.9 16H721c8.6 0 15.9-7.2 15.9-16 0-8.9-7.2-16-15.9-16m79.8 367.9c0 35.2-28.5 63.8-63.8 63.8H289c-35.2 0-63.8-28.5-63.8-63.8v-448c0-35.2 28.5-63.8 63.8-63.8h448c35.2 0 63.8 28.5 63.8 63.8v448m-63.9-543.8H289.1c-53 0-95.9 42.9-95.9 95.9v447.8c0 53 43 95.9 95.9 95.9h447.8c53 0 95.9-43 95.9-95.9V287.7c0-53-42.9-95.9-95.9-95.9M465.1 367.7h-48v-48c0-8.6-7.2-15.9-16-15.9-8.9 0-16 7.1-16 15.9v48h-48c-8.6 0-15.9 7.2-15.9 16 0 8.9 7.1 16 15.9 16h48v48c0 8.6 7.2 15.9 16 15.9 8.9 0 16-7.1 16-15.9v-48h48c8.6 0 15.9-7.2 15.9-16 0-8.9-7.1-16-15.9-16m-40.3 257l34-34c6.1-6.1 6.2-16.3-0.1-22.6-6.3-6.3-16.3-6.3-22.6-0.1l-34 34-34-34c-6.1-6.1-16.3-6.2-22.6 0.1-6.3 6.3-6.3 16.3-0.1 22.6l34 34-34 34c-6.1 6.1-6.2 16.3 0.1 22.6 6.3 6.3 16.3 6.3 22.6 0.1l34-34 34 34c6.1 6.1 16.3 6.2 22.6-0.1 6.3-6.3 6.3-16.3 0.1-22.6l-34-34',
                onclick: callback
            },
            mytool: {
                show: true,
                title: "菜单",
                icon: 'path://M128.13 255.96h767.89c23.56 0 42.66-19.1 42.66-42.66s-19.1-42.66-42.66-42.66H128.13c-23.56 0-42.66 19.1-42.66 42.66s19.1 42.66 42.66 42.66zM896.02 469.27H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66zM896.02 767.89H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66z',
                onclick: ($event) => {
                    // var menupanel = <HTMLElement>$event.scheduler.api.getDom().parentNode.previousSibling;
                    var menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    if (menupanel.hasChildNodes()) {
                        menupanel.firstElementChild.setAttribute('style', 'display:block')
                    }
                }
            }
        },
        tooltip: {
            show: true,
            confine: true,
            formatter: (param) => {
                return "<div>" + param.title + "</div>"; // 自定义的DOM结构
            },
            backgroundColor: "#F8F8FF",
            textStyle: {
                fontSize: 12,
            },
            extraCssText: 'padding:1px 2px;box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);'
        },
    };
    return paramJsonObj;
}

export const getToolboxIncludeExcel = function (style: any, callback?: (...arg: any[]) => void): any {
    let paramJsonObj = {
        show: true,
        itemGap: 10,
        showTitle: false,
        right: "10px", // 右边距
        top: "0%", // 上边距
        itemSize: style.toolboxSize, //工具栏 icon 的大小
        feature: {
            myExportExcel: {
                show: true,
                title: '导出表格',
                icon: 'path://M825.6 376.2H697.8v78.3h127.8v-78.3z m0 100.6H697.8v79.9h127.8v-79.9z m0-201.3H697.8v78.3h127.8v-78.3z m0 397.7H697.8v79.9h127.8v-79.9z m59.1-477.5H578.1c-3.2 0-6.4 0-9.6 1.6v-84.6l-455.2 91v618.1l453.6 89.4v-81.4c3.2 1.6 6.4 1.6 9.6 1.6h306.6c16 0 27.2-12.8 27.2-28.7V224.4c1.5-15.9-11.2-28.7-25.6-28.7zM420 644.5l-54.3-3.2-41.5-103.8-44.7 97.4-51.1-3.2 65.5-118.2-59.1-129.4 51.1-3.2 35.1 97.4h6.4l38.3-103.8 54.3-3.2-68.7 137.3L420 644.5z m456.7 151.7H566.9v-43.1h103.8v-79.9H566.9v-17.6h103.8v-78.3H566.9v-20.8h103.8v-79.9H566.9v-22.4h103.8v-78.3H566.9v-20.8h103.8v-78.3H566.9v-44.7h309.8v564.1z m-51.1-218.8H697.8v78.3h127.8v-78.3z m0 0',
                onclick: callback
            },
            mytool: {
                show: true,
                title: "菜单",
                icon: 'path://M128.13 255.96h767.89c23.56 0 42.66-19.1 42.66-42.66s-19.1-42.66-42.66-42.66H128.13c-23.56 0-42.66 19.1-42.66 42.66s19.1 42.66 42.66 42.66zM896.02 469.27H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66zM896.02 767.89H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66z',
                onclick: ($event) => {
                    // var menupanel = <HTMLElement>$event.scheduler.api.getDom().parentNode.previousSibling;
                    var menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    if (menupanel.hasChildNodes()) {
                        menupanel.firstElementChild.setAttribute('style', 'display:block')
                    }
                }
            },
        },
        tooltip: {
            show: true,
            confine: true,
            formatter: (param) => {
                return "<div>" + param.title + "</div>"; // 自定义的DOM结构
            },
            backgroundColor: "#F8F8FF",
            textStyle: {
                fontSize: 12,
            },
            extraCssText: 'padding:1px 2px;box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);'
        },
    }
    return paramJsonObj;
}

export const getToolboxIncludeRestore = function (style: any): any {
    let paramJsonObj = {
        show: true,
        itemGap: 10,
        showTitle: false,
        right: "10px", // 右边距
        top: "0%", // 上边距
        itemSize: 14, //工具栏 icon 的大小
        feature: {
            restore: {},
            mytool: {
                show: true,
                title: "菜单",
                icon: 'path://M128.13 255.96h767.89c23.56 0 42.66-19.1 42.66-42.66s-19.1-42.66-42.66-42.66H128.13c-23.56 0-42.66 19.1-42.66 42.66s19.1 42.66 42.66 42.66zM896.02 469.27H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66zM896.02 767.89H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66z',
                onclick: ($event) => {
                    // var menupanel = <HTMLElement>$event.scheduler.api.getDom().parentNode.previousSibling;
                    var menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    if (menupanel.hasChildNodes()) {
                        menupanel.firstElementChild.setAttribute('style', 'display:block')
                    }
                }
            }
        },
    };
    return paramJsonObj;
}

/**
 * 获取带导出Excel图标的toolbox 已废弃
 * @param callback 
 * @deprecated
 */
export const getToolboxIncludeExcelIcon = (callback: (...arg: any[]) => void): any => {
    let myExportExcel = {
        show: true,
        title: '导出表格',
        icon: 'path://M825.6 376.2H697.8v78.3h127.8v-78.3z m0 100.6H697.8v79.9h127.8v-79.9z m0-201.3H697.8v78.3h127.8v-78.3z m0 397.7H697.8v79.9h127.8v-79.9z m59.1-477.5H578.1c-3.2 0-6.4 0-9.6 1.6v-84.6l-455.2 91v618.1l453.6 89.4v-81.4c3.2 1.6 6.4 1.6 9.6 1.6h306.6c16 0 27.2-12.8 27.2-28.7V224.4c1.5-15.9-11.2-28.7-25.6-28.7zM420 644.5l-54.3-3.2-41.5-103.8-44.7 97.4-51.1-3.2 65.5-118.2-59.1-129.4 51.1-3.2 35.1 97.4h6.4l38.3-103.8 54.3-3.2-68.7 137.3L420 644.5z m456.7 151.7H566.9v-43.1h103.8v-79.9H566.9v-17.6h103.8v-78.3H566.9v-20.8h103.8v-79.9H566.9v-22.4h103.8v-78.3H566.9v-20.8h103.8v-78.3H566.9v-44.7h309.8v564.1z m-51.1-218.8H697.8v78.3h127.8v-78.3z m0 0',
        onclick: callback
    }
    return myExportExcel
}

export function getCommonToolbox() {

    const toolbox = {
        show: true,
        showTitle: false,
        itemSize: 14,
        feature: {
            dataZoom: {
                show: true,
                title: {
                    zoom: '区域缩放',
                    back: '区域缩放还原'
                }
            },
            dataView: {
                show: true,
                title: '数据视图'
            },
            restore: {
                show: true,
                title: "还原"
            },
            saveAsImage: {
                title: '保存'
            },
        },
        tooltip: {
            show: true,
            confine: true,
            formatter: (param) => {
                return "<div>" + param.title + "</div>"; // 自定义的DOM结构
            },
            backgroundColor: "#F8F8FF",
            textStyle: {
                fontSize: 12,
            },
            extraCssText: 'padding:1px 2px;box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);'
        },
    }
    return toolbox;
}

//todo 声学分析
export const getNoiseAnalysisLineToolbox = (style, item: Array<string>, funcObj?) => {
    let paramJsonObj = {
        show: true,
        itemGap: style.toolbox.itemGap,
        showTitle: true,
        right: style.toolbox.right, // 右边距 
        top: 10, // 上边距
        itemSize: style.toolbox.itemSize, //工具栏 icon 的大小
        feature: {
            myTool_interval: {
                show: item.includes('switchInterval'),
                title: '切换显示刻度',
                // icon: 'path://M896 256v554.666667H170.666667V256h725.333333zM213.333333 298.666667v469.333333h640V298.666667H213.333333z m170.666667 0h42.666667v469.333333H384V298.666667z m256 0h42.666667v469.333333h-42.666667V298.666667z',
                icon: 'path://M511.866 696.295c-16.568 0-30-13.432-30-30V357.706c0-16.568 13.432-30 30-30 16.569 0 30 13.432 30 30v308.589c-0.001 16.568-13.431 30-30 30zM317.316 836.225h-80.61C173.457 836.225 122 784.768 122 721.519V302.481c0-63.249 51.457-114.706 114.706-114.706h80.61c63.249 0 114.706 51.457 114.706 114.706v419.038c0 63.249-51.457 114.706-114.706 114.706z m-80.61-588.45c-30.165 0-54.706 24.541-54.706 54.706v419.038c0 30.165 24.541 54.706 54.706 54.706h80.61c30.165 0 54.706-24.541 54.706-54.706V302.481c0-30.165-24.541-54.706-54.706-54.706h-80.61zM787.294 836.225h-80.61c-63.249 0-114.706-51.457-114.706-114.706V302.481c0-63.249 51.457-114.706 114.706-114.706h80.61c63.249 0 114.706 51.457 114.706 114.706v419.038c0 63.249-51.457 114.706-114.706 114.706z m-80.61-588.45c-30.165 0-54.706 24.541-54.706 54.706v419.038c0 30.165 24.541 54.706 54.706 54.706h80.61c30.165 0 54.706-24.541 54.706-54.706V302.481c0-30.165-24.541-54.706-54.706-54.706h-80.61z',
                onclick: ($event) => {
                    const menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    const children = menupanel.childNodes;
                    const ev = <MouseEvent>window.event
                    const width = document.body.clientWidth
                    for (const item of <any>children) {
                        if ((item.getAttribute('class')).indexOf('switchInterval') > 0) {
                            item.setAttribute('style', 'display:block')
                            item.setAttribute('style', 'top:' + ev.clientY + 'px')
                            item.setAttribute('style', 'right:' + (width - ev.clientX - 4) + 'px')
                        }
                    }
                }
            },
            myTool_monitorItem: {
                show: item.includes('switchMultipleChoice') || item.includes('switchValue'),
                title: '切换显示图例',
                icon: 'path://M512.4 738c-120.8 0-219.1-98.3-219.1-219.1s98.3-219.1 219.1-219.1S731.5 398 731.5 518.9 633.2 738 512.4 738z m0-375.6c-86.3 0-156.5 70.2-156.5 156.5s70.2 156.5 156.5 156.5 156.5-70.2 156.5-156.5-70.2-156.5-156.5-156.5zM324.6 550.2H121.1c-17.3 0-31.3-14-31.3-31.3s14-31.3 31.3-31.3h203.5c17.3 0 31.3 14 31.3 31.3s-14 31.3-31.3 31.3zM903.7 550.2H700.2c-17.3 0-31.3-14-31.3-31.3s14-31.3 31.3-31.3h203.5c17.3 0 31.3 14 31.3 31.3s-14 31.3-31.3 31.3z',
                onclick: ($event) => {
                    const menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    const children = menupanel.childNodes;
                    const ev = <MouseEvent>window.event
                    const width = document.body.clientWidth
                    for (const item of <any>children) {
                        if ((item.getAttribute('class')).indexOf('multipleChoice') > 0) {
                            item.setAttribute('style', 'display:block')
                            item.setAttribute('style', 'top:' + ev.clientY + 'px')
                            item.setAttribute('style', 'right:' + (width - ev.clientX - 4) + 'px')
                        }
                    }
                }
            },
            myTool_showspec: {
                show: item.includes('spec'),
                title: '频谱图',
                icon: 'path://M252.77060978 417.73413954v400.62749051h-47.13223983V417.73413954h47.13223983M299.90284958 370.60189971H158.5047493V865.4952507h141.39810028V370.60189971z m235.66396075-164.96491059v612.72464093h-47.1322398V205.63698912h47.1322398M582.69905013 158.5047493H441.30094987v706.9905014h141.39810026V158.5047493z m235.66396075 117.83128995v542.0255908h-47.13223981V276.33603925h47.13223981M865.4952507 229.20379943H724.09715042V865.4952507H865.4952507V229.20379943z',
                onclick: () => {
                    if (funcObj) { funcObj.bcacShowSpec.emit('频谱图') }
                }
            },
            brush: {
                show: item.includes('brush'),
                type: ['lineX', 'clear'],
                iconStyle: {
                    color: 'black'
                },
            },
            myTool_enlarge: {
                show: item.includes('brush_enlarge'),
                title: '框选放大',
                icon: 'path://M181.808 329.956L2.276 512l179.532 182.044V557.502h269.289v-91.013h-269.29V329.956zM1021.724 512L842.192 329.956v136.533H572.903v91.022h269.29v136.533L1021.723 512z',
                iconStyle: {
                    color: 'black'
                },
                onclick: () => {
                    if (funcObj) { funcObj.bcacBrushEnlarge.emit('框选放大') }
                }
            },
            myTool_restore: {
                show: item.includes('brush_restore'),
                title: '框选还原',
                icon: 'path://M280.02 466.489H2.277v91.022H280.02v136.533L465.187 512 280.021 329.956v136.533z m741.704 0H743.97V329.956L558.813 512l185.166 182.044V557.502h277.745v-91.013z',
                iconStyle: {
                    color: 'black'
                },
                onclick: () => {
                    if (funcObj) { funcObj.bcacBrushRestore.emit('框选还原') }
                }
            },
            myTool_calculation: {
                show: item.includes('calculation'),
                title: '计算框选',
                icon: 'path://M408.43734282 408.43734282H356.65540741v-155.3445926h362.47112059v155.3445926h-310.68918518z m0-51.78193541H667.34459259v-51.78193541H408.43734282V356.65540741zM201.31081482 97.74815763h673.16030577v828.50368474H201.31081482V97.74815763z m51.7819354 51.78072178v724.94224118H822.68918518V149.52887941H253.09275022zM356.65540741 512h51.78193541v51.78193541H356.65540741V512z m155.34459259 0h51.78193541v51.78193541H512V512z m155.34459259 0h51.78193541v51.78193541H667.34459259V512z m-310.68918518 103.56265718h51.78193541V667.34459259H356.65540741v-51.78193541z m155.34459259 0h51.78193541V667.34459259H512v-51.78193541z m-155.34459259 103.56387082h51.78193541v51.78072178H356.65540741v-51.78072178z m155.34459259 0h51.78193541v51.78072178H512v-51.78072178z m155.34459259-103.56387082h51.78193541v155.3445926H667.34459259v-155.3445926zM201.31081482 97.74815763h673.16030577v51.78072178H201.31081482v-51.78072178z',
                onclick: () => {
                    if (funcObj) { funcObj.bcacBrushCalculation.emit('计算框选') }
                }
            },
            mytool: {
                show: true,
                title: "菜单",
                icon: 'path://M128.13 255.96h767.89c23.56 0 42.66-19.1 42.66-42.66s-19.1-42.66-42.66-42.66H128.13c-23.56 0-42.66 19.1-42.66 42.66s19.1 42.66 42.66 42.66zM896.02 469.27H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66zM896.02 767.89H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66z',
                onclick: ($event) => {
                    var menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    if (menupanel.hasChildNodes()) {
                        menupanel.firstElementChild.setAttribute('style', 'display:block')
                    }
                }
            }
        },
    };
    return paramJsonObj;
}


//todo 声学分析下拉
export const getNoiseDropboxLineToolbox = (style, dropToolboxData: any, funcObj?) => {
    let paramJsonObj = {
        show: true,
        itemGap: style.toolbox.itemGap,
        showTitle: true,
        right: style.toolbox.right, // 右边距 
        top: style.toolbox.top, // 上边距
        itemSize: style.toolbox.itemSize, //工具栏 icon 的大小
        feature: {
            myTool_interval: {
                show: dropToolboxData.length === 0 ? false : dropToolboxData.toolboxItem.includes('switchInterval'),
                title: '切换显示刻度',
                // icon: 'path://M896 256v554.666667H170.666667V256h725.333333zM213.333333 298.666667v469.333333h640V298.666667H213.333333z m170.666667 0h42.666667v469.333333H384V298.666667z m256 0h42.666667v469.333333h-42.666667V298.666667z',
                icon:'path://M511.866 696.295c-16.568 0-30-13.432-30-30V357.706c0-16.568 13.432-30 30-30 16.569 0 30 13.432 30 30v308.589c-0.001 16.568-13.431 30-30 30zM317.316 836.225h-80.61C173.457 836.225 122 784.768 122 721.519V302.481c0-63.249 51.457-114.706 114.706-114.706h80.61c63.249 0 114.706 51.457 114.706 114.706v419.038c0 63.249-51.457 114.706-114.706 114.706z m-80.61-588.45c-30.165 0-54.706 24.541-54.706 54.706v419.038c0 30.165 24.541 54.706 54.706 54.706h80.61c30.165 0 54.706-24.541 54.706-54.706V302.481c0-30.165-24.541-54.706-54.706-54.706h-80.61zM787.294 836.225h-80.61c-63.249 0-114.706-51.457-114.706-114.706V302.481c0-63.249 51.457-114.706 114.706-114.706h80.61c63.249 0 114.706 51.457 114.706 114.706v419.038c0 63.249-51.457 114.706-114.706 114.706z m-80.61-588.45c-30.165 0-54.706 24.541-54.706 54.706v419.038c0 30.165 24.541 54.706 54.706 54.706h80.61c30.165 0 54.706-24.541 54.706-54.706V302.481c0-30.165-24.541-54.706-54.706-54.706h-80.61z',
                onclick: ($event) => {
                    const menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    const children = menupanel.childNodes;
                    const ev = <MouseEvent>window.event
                    const width = document.body.clientWidth
                    for (const item of <any>children) {
                        if ((item.getAttribute('class')).indexOf('switchInterval') > 0) {
                            item.setAttribute('style', 'display:block')
                            item.setAttribute('style', 'top:' + ev.clientY + 'px')
                            item.setAttribute('style', 'right:' + (width - ev.clientX - 4) + 'px')
                        }
                    }
                }
            },
            myTool_singleChoice: {
                show: dropToolboxData.length === 0 ? false : dropToolboxData.toolboxItem.includes('switchSingleChoice'),
                title: '切换显示值',
                icon: 'path://M907.392 114.56a32.768 32.768 0 0 0-15.872-2.24H768.256a32 32 0 0 0 0 64h47.616L639.744 352.448 408.896 121.536A33.472 33.472 0 0 0 383.808 112a33.024 33.024 0 0 0-24.704 9.472l-253.696 253.76a33.152 33.152 0 0 0 46.848 46.848l231.232-231.296 231.168 231.168c6.848 6.912 16 9.92 25.088 9.536a33.024 33.024 0 0 0 25.088-9.536l199.424-199.424v49.728a32 32 0 0 0 64 0v-128a31.808 31.808 0 0 0-20.864-29.696zM128.256 656.256a32 32 0 0 0-32 32v192a32 32 0 1 0 64 0v-192a32 32 0 0 0-32-32z m256-224a32 32 0 0 0-32 32v416a32 32 0 0 0 64 0v-416a32 32 0 0 0-32-32z m519.872 187.648h-1.92c-32.128 0-58.24-27.648-58.24-61.632 0-11.264 5.056-23.488 5.056-23.616a28.8 28.8 0 0 0-8.896-33.728l-0.576-0.384-56-33.024-0.576-0.256a28.48 28.48 0 0 0-31.744 6.72c-6.848 7.488-28.416 26.88-45.888 26.88-17.472 0-39.232-19.776-46.08-27.392a28.672 28.672 0 0 0-21.056-9.216 25.472 25.472 0 0 0-10.624 2.24l-0.64 0.256-57.92 33.792-0.576 0.384a28.864 28.864 0 0 0-8.96 33.728c0 0.128 5.056 12.352 5.056 23.616 0 33.984-26.112 61.632-58.24 61.632h-1.92c-9.344-0.128-17.024 8.512-19.456 22.144-0.192 1.024-4.672 26.496-4.672 46.528s4.48 45.376 4.672 46.528c2.432 13.376 9.856 22.016 19.072 22.016h2.304c32.128 0 58.24 27.648 58.24 61.76 0 11.136-5.056 23.488-5.056 23.488a28.864 28.864 0 0 0 8.896 33.728l0.512 0.384 54.976 32.64 0.576 0.256a28.352 28.352 0 0 0 31.808-7.104c6.464-7.36 28.864-28.48 46.848-28.48s40.128 20.992 47.104 29.12a27.84 27.84 0 0 0 31.744 7.232l0.64-0.256 56.896-33.344 0.64-0.384a28.992 28.992 0 0 0 8.896-33.728s-5.056-12.352-5.056-23.488c0-34.112 26.112-61.76 58.24-61.76h1.92c9.344 0.256 17.024-8.512 19.456-22.016 0.192-1.152 4.672-26.496 4.672-46.528s-4.48-45.504-4.672-46.528c-2.432-13.76-10.112-22.336-19.456-22.208zM861.312 721.6c-36.16 1.984-65.088 33.984-65.088 73.024 0 12.992 4.736 25.472 5.76 28.032L758.848 848h-0.128c-0.64 0-1.216-0.128-1.344-0.384a121.088 121.088 0 0 0-16.064-15.104c-13.44-10.624-26.176-16-38.016-16-11.712 0-24.384 5.376-37.76 15.744-8.96 6.976-15.168 14.016-15.936 14.848a3.392 3.392 0 0 1-1.344 0.384h-0.128l-41.664-24.768c1.088-2.624 5.824-15.104 5.824-28.096 0-38.976-28.864-70.976-65.088-73.024a225.152 225.152 0 0 1-3.392-33.28c0-12.864 2.816-30.016 3.328-33.152 36.224-1.984 65.152-33.984 65.152-73.024 0-12.992-4.736-25.344-5.76-28.032l44.032-25.728h0.128c0.768 0 1.408 0.256 1.6 0.512 0.768 0.768 6.912 7.488 15.872 14.272 13.12 9.984 25.6 15.104 37.056 15.104 11.328 0 23.68-4.992 36.8-14.848 8.896-6.656 14.976-13.248 15.744-14.016a3.84 3.84 0 0 1 1.6-0.384h0.128l42.496 25.152c-1.024 2.496-5.76 14.976-5.76 28.032 0 38.976 28.864 70.976 65.088 73.024 0.576 3.136 3.392 20.224 3.392 33.152 0 12.992-2.816 30.272-3.392 33.216z m-157.056-97.728a63.808 63.808 0 0 0-63.232 64.384c0 35.648 28.288 64.384 63.232 64.384s63.232-28.736 63.232-64.384a63.808 63.808 0 0 0-63.232-64.384z',
                onclick: ($event) => {
                    const menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    const children = menupanel.childNodes;
                    const ev = <MouseEvent>window.event
                    const width = document.body.clientWidth
                    for (const item of <any>children) {
                        if ((item.getAttribute('class')).indexOf('singleChoice') > 0) {
                            item.setAttribute('style', 'display:block')
                            item.setAttribute('style', 'top:' + ev.clientY + 'px')
                            item.setAttribute('style', 'right:' + (width - ev.clientX - 4) + 'px')
                        }
                    }
                }
            },
            myTool_multipleChoice: {
                show: dropToolboxData.length === 0 ? false : dropToolboxData.toolboxItem.includes('switchMultipleChoice'),
                title: '切换显示图例',
                icon: 'path://M512.4 738c-120.8 0-219.1-98.3-219.1-219.1s98.3-219.1 219.1-219.1S731.5 398 731.5 518.9 633.2 738 512.4 738z m0-375.6c-86.3 0-156.5 70.2-156.5 156.5s70.2 156.5 156.5 156.5 156.5-70.2 156.5-156.5-70.2-156.5-156.5-156.5zM324.6 550.2H121.1c-17.3 0-31.3-14-31.3-31.3s14-31.3 31.3-31.3h203.5c17.3 0 31.3 14 31.3 31.3s-14 31.3-31.3 31.3zM903.7 550.2H700.2c-17.3 0-31.3-14-31.3-31.3s14-31.3 31.3-31.3h203.5c17.3 0 31.3 14 31.3 31.3s-14 31.3-31.3 31.3z',
                // icon:'path://M908.49 562.043H754.526c-23.01 114.216-123.222 200.183-243.363 200.183S290.81 676.259 267.8 562.043H113.836c-27.431 0-49.667-22.405-49.667-50.044 0-27.64 22.236-50.044 49.667-50.044H267.8c23.01-114.216 123.222-200.183 243.363-200.183s220.353 85.967 243.363 200.183H908.49c27.431 0 49.666 22.404 49.666 50.044 0 27.64-22.236 50.044-49.666 50.044zM511.163 361.865c-82.291 0-148.998 67.218-148.998 150.135s66.707 150.135 148.998 150.135S660.16 594.917 660.16 512s-66.706-150.135-148.997-150.135z',
                onclick: ($event) => {
                    const menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    if (menupanel.hasChildNodes()) {
                        const children = menupanel.childNodes;
                        const ev = <MouseEvent>window.event
                        const width = document.body.clientWidth
                        for (const item of <any>children) {
                            if ((item.getAttribute('class')).indexOf('multipleChoice') > 0) {
                                item.setAttribute('style', 'display:block')
                                item.setAttribute('style', 'top:' + ev.clientY + 'px')
                                item.setAttribute('style', 'right:' + (width - ev.clientX - 4) + 'px')

                            }
                        }
                    }
                }
            },
            brush: {
                show: dropToolboxData.length === 0 ? false : dropToolboxData.toolboxItem.includes('brush'),
                type: ['lineX', 'clear'],
                iconStyle: {
                    color: 'black'
                },
            },
            myTool_enlarge: {
                show: dropToolboxData.length === 0 ? false : dropToolboxData.toolboxItem.includes('brush_enlarge'),
                title: '框选放大',
                icon: 'path://M181.808 329.956L2.276 512l179.532 182.044V557.502h269.289v-91.013h-269.29V329.956zM1021.724 512L842.192 329.956v136.533H572.903v91.022h269.29v136.533L1021.723 512z',
                iconStyle: {
                    color: 'black'
                },
                onclick: () => {
                    if (funcObj) { funcObj.bcacBrushEnlarge.emit('框选放大') }

                }
            },
            myTool_restore: {
                show: dropToolboxData.length === 0 ? false : dropToolboxData.toolboxItem.includes('brush_restore'),
                title: '框选还原',
                icon: 'path://M280.02 466.489H2.277v91.022H280.02v136.533L465.187 512 280.021 329.956v136.533z m741.704 0H743.97V329.956L558.813 512l185.166 182.044V557.502h277.745v-91.013z',
                iconStyle: {
                    color: 'black'
                },
                onclick: () => {
                    if (funcObj) { funcObj.bcacBrushRestore.emit('框选还原') }
                }
            },
            myTool_calculation: {
                show: dropToolboxData.length === 0 ? false : dropToolboxData.toolboxItem.includes('calculation'),
                title: '计算框选',
                icon: 'path://M408.43734282 408.43734282H356.65540741v-155.3445926h362.47112059v155.3445926h-310.68918518z m0-51.78193541H667.34459259v-51.78193541H408.43734282V356.65540741zM201.31081482 97.74815763h673.16030577v828.50368474H201.31081482V97.74815763z m51.7819354 51.78072178v724.94224118H822.68918518V149.52887941H253.09275022zM356.65540741 512h51.78193541v51.78193541H356.65540741V512z m155.34459259 0h51.78193541v51.78193541H512V512z m155.34459259 0h51.78193541v51.78193541H667.34459259V512z m-310.68918518 103.56265718h51.78193541V667.34459259H356.65540741v-51.78193541z m155.34459259 0h51.78193541V667.34459259H512v-51.78193541z m-155.34459259 103.56387082h51.78193541v51.78072178H356.65540741v-51.78072178z m155.34459259 0h51.78193541v51.78072178H512v-51.78072178z m155.34459259-103.56387082h51.78193541v155.3445926H667.34459259v-155.3445926zM201.31081482 97.74815763h673.16030577v51.78072178H201.31081482v-51.78072178z',
                onclick: () => {
                    if (funcObj) { funcObj.bcacBrushCalculation.emit('计算框选') }
                }
            },
            mytool: {
                show: true,
                title: "菜单",
                icon: 'path://M128.13 255.96h767.89c23.56 0 42.66-19.1 42.66-42.66s-19.1-42.66-42.66-42.66H128.13c-23.56 0-42.66 19.1-42.66 42.66s19.1 42.66 42.66 42.66zM896.02 469.27H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66zM896.02 767.89H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66z',
                onclick: ($event) => {
                    var menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    if (menupanel.hasChildNodes()) {
                        menupanel.firstElementChild.setAttribute('style', 'display:block')
                    }
                }
            }
        },
    };
    return paramJsonObj;
}


export const getNoiseEventWaveToolbox = function (style: any): any {
    let paramJsonObj = {
        show: true,
        itemGap: style.toolbox.itemGap,
        showTitle: false,
        right: style.toolbox.right, // 右边距
        top: "0%", // 上边距
        itemSize: style.toolbox.itemSize, //工具栏 icon 的大小
        feature: {
            dataZoom: { yAxisIndex: 'none' },
            mytool: {
                show: true,
                title: "菜单",
                icon: 'path://M128.13 255.96h767.89c23.56 0 42.66-19.1 42.66-42.66s-19.1-42.66-42.66-42.66H128.13c-23.56 0-42.66 19.1-42.66 42.66s19.1 42.66 42.66 42.66zM896.02 469.27H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66zM896.02 767.89H128.13c-23.56 0-42.66 19.1-42.66 42.66 0 23.56 19.1 42.66 42.66 42.66h767.89c23.56 0 42.66-19.1 42.66-42.66 0-23.56-19.1-42.66-42.66-42.66z',
                onclick: ($event) => {
                    var menupanel = <HTMLElement>$event.scheduler.api.getDom().previousSibling;
                    if (menupanel.hasChildNodes()) {
                        menupanel.firstElementChild.setAttribute('style', 'display:block')
                    }
                }
            }
        },
    };
    return paramJsonObj;
}


export const getNoiseEventWaveToolboxV2 = function (): any {
    let paramJsonObj = {
        show: true,
        itemSize:0,
        showTitle:false,
        feature: {
            dataZoom: { yAxisIndex: 'none' },
        },
        iconStyle:{
            opacity:0
        }
    }
    return paramJsonObj;
}


//todo 声学分析下拉
export const getNoiseDropboxLineToolboxV2 = () => {
    let paramJsonObj = {
        show: true,
        itemSize: 0,
        showTitle: false,
        feature: {
            brush: {
                show: true,
                type: ['lineX', 'clear'],
            }
        },
        iconStyle: {
            opacity: 0
        }
    };
    return paramJsonObj;
}

export const getNoiseDropboxLineBrush = () => {
    let paramJsonObj = {
        xAxisIndex: 'all',
        brushLink: 'all',
        outOfBrush: {
            colorAlpha: 0.1
        },
        throttleType: 'debounce',
        throttleDelay: 500
    };
    return paramJsonObj;
}

export const getNoiseAnalysisBrush = () => {
    let brush = {
        toolbox: ['lineX', 'clear'],
        xAxisIndex: 0,
        brushLink: 0,
        outOfBrush: {  //定义 在选中范围外 的视觉元素
            colorAlpha: 0.1
        },
        throttleType: 'debounce',
        throttleDelay: 1000
    }
    return brush;
}